// import Icon from '@assets/icons/check-big.svg'
import { Achievements } from '@components/_ui/Achievements'
import { Button } from '@components/_ui/Button'
import { formatToPrettyDate } from '@lib/formatToPrettyDate'
import { Slots } from '@types'
// import { getDay } from 'date-fns'
import { useWatch } from 'react-hook-form'

import s from './ThanksPage.module.scss'
import type { ThanksPageProps } from './ThanksPage.props'

// const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export function ThanksPage({ data }: ThanksPageProps) {
  const cleaningType = useWatch({ name: 'requested_cleaning_type' })
  const name = useWatch({ name: 'name' })
  const email = useWatch({ name: 'email' })
  const date = useWatch({ name: 'date' })
  // const upsale = useWatch({ name: 'upsale' })
  const time = useWatch({ name: 'time' })
  const timeObj = JSON.parse(time) as Slots[string][number]

  // const isNextCleanings = useWatch({ name: 'is_next_cleanings' })
  // const recurringDate = useWatch({ name: 'recurring_plan_start_date' })
  // const recurringTime = useWatch({ name: 'recurring_plan_start_time' })
  // const recurringTimeObj = JSON.parse(recurringTime) as Slots[string][number]

  // const currentData = cleaningType === 'airbnb'
  //   ? data?.airbnb
  //   : upsale
  //     ? data?.[upsale === 'bi_weekly' ? 'bi-weekly' : 'monthly']
  //     : data?.other

  const currentData = cleaningType === 'airbnb'
    ? data?.airbnb
    : data?.other

  const title = currentData?.title?.replace('[name]', name)
  const subtitle = currentData?.subtitle?.replace('[email]', email)

  const achievements = [
    ...((currentData?.achievements && currentData.achievements?.length)
      ? currentData.achievements.map((i) => ({
        ...i,
        text: i.text.replaceAll('[date]', `${formatToPrettyDate(date)} - ${timeObj?.time_display}`)
      }))
      : []
    ),
    ...(cleaningType !== 'airbnb' ? [
      // {
      //   title: `Your cleaner is ${(isNextCleanings === 'true' ? recurringTimeObj : timeObj).team_display_name}`,
      //   text: (isNextCleanings === 'true' ? recurringTimeObj : timeObj).team_description,
      //   icon: (isNextCleanings === 'true' ? recurringTimeObj : timeObj).team_photo
      // },
      {
        title: `Your cleaner is ${timeObj.team_display_name}`,
        text: timeObj.team_description,
        icon: timeObj.team_photo
      }
      // ...(isNextCleanings === 'true' ? [
      //   {
      //     title: `Your ${upsale === 'bi_weekly' ? 'Bi-Weekly' : 'Monthly'} Cleaning Schedule is confirmed`,
      //     text: `The first Recurring Visit is scheduled for ${formatToPrettyDate(recurringDate)} - ${recurringTimeObj?.time_display},${' '}
      //     and will repeat every ${upsale === 'bi_weekly' ? 'two' : 'four'}${' '}
      //     weeks on ${daysOfWeek[getDay(new Date(`${isNextCleanings === 'true' ? recurringDate : date}T00:00:00`))]}`,
      //     icon: Icon
      //   }
      // ] : [])
    ] : [])
  ]

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <h1
          className={s.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        {subtitle && (
          <div
            className={s.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}

        <Achievements
          achievements={achievements}
          reversed
          itemClassName={s.item}
          iconWrapperClassName={s.iconWrapper}
        />

        {currentData?.image && (
          <img
            src={currentData.image}
            alt="Picture"
            width={579}
            height={388}
            className={s.img}
          />
        )}
      </div>

      <div className={s.btnWrapper}>
        <div className={s.btnContainer}>
          <Button onClick={() => window.location.href = '/'}>
            Go To Mainpage
          </Button>
        </div>
      </div>
    </div>
  )
}
